//#region src/constants/aggregation.ts
var e = "median", t = "mean", n = "max", r = "min", i = "count", a = "cardinality", o = "range", s = "label_name", c = "label_numeric", l = "any", u = "Unknown", d = "percent", f = "value";
//#endregion
export { a as CARDINALITY, i as COUNT, n as MAX, t as MEAN, e as MEDIAN, r as MIN, d as PERCENT, o as RANGE, l as REPORTING_FILTER_SELECT_ALL, s as SORTING_LABEL_NAME, c as SORTING_LABEL_NUMERIC, u as UNKNOWN, f as VALUE };
